import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './Routes';
import Navigation from './shared/components/Navigation';
import AuthSyncNotification from './features/user/auth/AuthSyncNotification';
import AutoLogoutNotification from './features/user/auth/AutoLogoutNotification';
import { initGA } from './utils/analytics';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { AuthProvider } from './features/user/auth/AuthContext';
import { CompanyProvider } from './shared/context/CompanyContext';
import { WatchlistProvider } from './shared/context/WatchlistContext';

// 初始化 Google Analytics 4
initGA();

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider>
      <CompanyProvider>
        <WatchlistProvider>
          <BrowserRouter>
            <Navigation />
            <AppRoutes />
            <AuthSyncNotification />
            <AutoLogoutNotification />
          </BrowserRouter>
        </WatchlistProvider>
      </CompanyProvider>
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);